import { Component, Input } from '@angular/core';
import { APPCONFIG } from '../../config'

@Component({
    selector: 'my-app-customizer',
    styles: [],
    template: require('./customizer.component.html'),
})

export class AppCustomizerComponent {
    AppConfig: any;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/customizer/customizer.component.ts